import { TimesheetBO } from "../timesheet/timesheet.modal";

export class GetRetuenPayrollBo  {
    currentpageno: number=1;
    pageitem: number= 10;
    orderColumn: string="ClientName";
    orderType: string= "asc";
    type: string="string";
    field: string="ClientName";
    operator: string = "startswith";
    value: string = "";
    matchCase: boolean=false;
    startTime: string | null;
    endTime: string | null;
    clientId: string | null;
    employeeId: string | null;
    paidDate: string | null;
    isPaid: boolean=false;
    serviceId:string;
    isApproved: boolean;
}









export class PaidBO {
    payrollIds: string[];
    payDate: string | null;
}


export class UnPaidBo {
    UnPaidPayrollBO: UnPaidPayrollBO[];
    payDate: string | null;
}




export class PayrollBO {
    // paidPayrollBO: PaidPayrollBO[];
    unPaidPayrollBO: UnPaidPayrollBO[];
}

export class UnPaidPayrollBO {
    timesheetId: string;
    clientName: string;
    clientId: string;
    employeeName: string;
    employeeId: string;
    serviceName: string;
    serviceId: string;
    serviceDate: string;
    hours: number;

    payrollPayRateBO:PayrollPayRateBO=new PayrollPayRateBO();
}

// export class PaidPayrollBO {
//     payrollId: string;
//     timesheetId: string | null;
//     clientName: string;
//     clientId: string;
//     employeeName: string;
//     employeeId: string;
//     serviceName: string;
//     serviceId: string;
//     payDate: string;
//     serviceDate: string;
//     payrollPayRateBO: PayrollPayRateBO;
// }

export class PayrollPayRateBO {
    totalAmount: number;
    rate: number;
}

export class functionpermission{
    payrollinformationunpaidpaydate:boolean=true;
    payrollinformationpaidpaydate:boolean=true;
    payrollinformationmovetounpaid:boolean=true;
    payrollinformationunpaidmultiplepaydate:boolean=true;
    payrollinformationpaidmultiplepaydate:boolean=true

}
